<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white py-4 d-flex flex-lg-column custom-footer-layout" id="kt_footer">
    <div
        class="d-flex align-items-center justify-content-between my-2"
        v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="text-dark">
        <span class="text-muted font-weight-bold mr-2">{{ currentYear }} &nbsp;&copy;&nbsp;</span>
        <router-link
            to="/"
            target="_blank"
            class="text-dark-75 text-hover-primary"
        ><b>Pultar Quadrat GmbH</b></router-link>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Ubuntu');

.custom-footer-layout{
  font-family: "ubuntu" !important;
}
</style>

<script>
import {mapGetters} from "vuex";

export default {
  name: "KTFooter",
  data() {
    return {
      currentYear: null,
    };
  },
  created() {
    var date = new Date();
    this.currentYear = date.getFullYear();
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
};
</script>
